import React, { useEffect, useRef } from 'react'
import {CreateJSLibs} from 'bc-react-package'

const COMP_NAME = "CharacterDrawerCanvas"

    // const
// const WORKING_AREA_W = 320
// const WORKING_AREA_H = 320
const WORKING_AREA_LEFT = 0
const WORKING_AREA_TOP = 0
const PEN_COLOR = "#f00"
const PEN_SIZE = 5
const MS_BETWEEN_PATHS = 300
const PATH_MAX_NUM = 100
const DRAW_BG_LINE_COLOR = "grey"

// #region Enumeration
const EventModeEnum = {
    "Mouse": 1,
    "Touch": 2
}
// #endregion Enumeration

let mblnInitialized = false
let mobjCanvas = null
let mcjStage = null
let mcjDrawingTemp = null

let mintPathCount = 0
let mblnBeginDrawing = false
let mintPathBeginTime = 0
// let mblnPlaybackBegin = false

let mintPlaybackBeginTime = 0
// let marrDrawedPathList = null
let mintCurrentPlaybackPathIdx = 0
let mblnRedraw1stPieceOfPath = true
let mblnInPlayback = false
let mcjCtnWhole = null
let mobjCurrentPath = {
    // "Color": "#000",
    // "PenSize": 1,
    "Points":[]
}
let mobjLastPoint = {
    "X": 0,
    "Y": 0
}
let marrDrawedPathList = []
let mbln1stStroke = true



function CharacterDrawerCanvas(props)
{
    console.log(COMP_NAME + ".Begin")
    console.log(COMP_NAME + ".props: ", props)

    let mrefCanvas = useRef(null)
    let mrefPaintedMe = useRef(null)
    mrefPaintedMe.current = PaintedMe

    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        Initialize()

        mblnInitialized = true
    }

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")


            mblnInitialized = false
        }
    }, [])    


    // GenerateCanvasHtml: function (CanvasID, Left, Top, Width, Height)
    // {
    //     console.log(xtype + ".GenerateCanvasHtml: ", CanvasID, Left, Top, Width, Height)

    //     var objCanvas = document.createElement('canvas');
    //     objCanvas.id = CanvasID;
    //     objCanvas.width = Width;
    //     objCanvas.height = Height;
    //     objCanvas.style.left = Left;
    //     objCanvas.style.top = Top;
    //     objCanvas.style.position = "absolute"

    //     return objCanvas
    //     // var strHtml = '<canvas id="' + CanvasID + '" width="' + Width.toString() +  'px" height="' + Height.toString() + 'px" style=left:' + Left.toString() + 'px;top:' + Top.toString() + 'px;position:relative;"></canvas>';

    //     // return strHtml; 
    // }, // end of GenerateCanvasHtml

    function ComponentCalledFunction (CallObject)
    {
        console.log(COMP_NAME + ".RegisterCalledFunctions: ")

        switch(CallObject.Action)
        {
            case "GetCanvasImag":
                GetCanvasImag()
                break;
            case "ClearCanvas":
                ClearCanvas()
                break
            case "PlayCanvas":
                PlayCanvas()
                break
            default:
                break;
        }

    }
    function RegisterCalledFunctions ()
    {
        console.log(COMP_NAME + ".RegisterCalledFunctions: ")

        let objCallbackData = {
            "Action": "RegisterCalledFunctions",
            "Function": ComponentCalledFunction
        }
        props.CallbackRef(objCallbackData)

    } // end of RegisterGetTeacherFeedback


    function PlayCanvas ()
    {
        console.log("PlayCanvas: ");
        console.log("marrDrawedPathList: ", marrDrawedPathList)

        // DrawedObject is an Array of Path

        console.log("mblnInPlayback: ", mblnInPlayback)
        if (mblnInPlayback)
        {
            return;
        }

        // marrDrawedPathList = DrawedObject;
        mintPlaybackBeginTime = (new Date()).getTime();
        mintCurrentPlaybackPathIdx = 0;
        mblnRedraw1stPieceOfPath = true;


        if (mcjCtnWhole !== null)
        {
            mcjCtnWhole.uncache();     // uncache 如果沒有先 Cache, 好像不會有問題
            RemoveAllChildrenFromContainer(mcjCtnWhole);

            // mcjStage.update();
        }

        StartPlayback();
    }
    function HandleTick (e)
    {
        console.log(COMP_NAME + ".HandleTick: ");

        var intNow = new Date().getTime();

        var intClipEscapedTime = intNow - mintPlaybackBeginTime;
        DrawPlaybackObjects(intClipEscapedTime);
        
        mcjStage.update();
    } // end of HandleTick

    function DrawPlaybackObjects(TimeEscaped)
    {
        console.log(COMP_NAME + "DrawPlaybackObjects: ", TimeEscaped);

        var objPlaybackClip =  marrDrawedPathList;
        console.log("marrDrawedPathList: ", marrDrawedPathList);

        var objPath = objPlaybackClip[mintCurrentPlaybackPathIdx];
        // var arrPoints = [];
        var i = 0;
        var blnTimeIsLaterFound = false;
        // var intFoundIdx = -1;
        var intCount = 0;
        // var intClipBT = 0;
        // var intPathBT = 0;
        var objPath4Playback = {};

        console.log("objPath: ", objPath);

            intCount = objPath.Points.length;
            console.log("intCount: ", intCount);

            // Draw
            objPath4Playback = 
            {
                // "AT":  objPath.AT,          // ActionType
                "BT": objPath.BT,           // BeginTime
                // "Color": objPath.Color,
                // "PenSize": objPath.PenSize,
                "Points": []
            };

            // console.log("DrawPlaybackObjects: intClipBT", intClipBT);
            while(!blnTimeIsLaterFound && (i < intCount))
            {
                // intPathBT = objPath.BT;
                console.log("objPath.Points[i].T: ", i, objPath.Points[i].T, TimeEscaped);
                if ((objPath.Points[i].T) <= TimeEscaped)
                {
                    objPath4Playback.Points.push(objPath.Points[i]);
                }
                else
                {
                    blnTimeIsLaterFound = true;
                }
                i++;
            } 

            console.log("objPath4Playback: ", objPath4Playback);

            if (objPath4Playback.Points.length >= 1)
            {
            	console.log("mcjCtnWhole: ", mcjCtnWhole);

                RedrawPath(objPath4Playback, mcjCtnWhole);

                if (objPath4Playback.Points.length === intCount)
                {
                    // end of Points (One Path)

                    RedrawPath(objPlaybackClip[mintCurrentPlaybackPathIdx], mcjCtnWhole);

                    if (mintCurrentPlaybackPathIdx < objPlaybackClip.length - 1)
                    {
                        mintCurrentPlaybackPathIdx++;
                        mintPlaybackBeginTime = (new Date()).getTime() + MS_BETWEEN_PATHS;
                        mblnRedraw1stPieceOfPath = true;
                    }
                    else
                    {
                        // end  playbckclip: 這個 clip 畫完 最後的 Path 了
                        console.log("End Clip: ", mintCurrentPlaybackPathIdx);

                        StopPlayback();

                        // recache for new draw path
					    mcjCtnWhole.cache(0, 0, mcjCtnWhole.InitWidth, mcjCtnWhole.InitHeight);
                        RemoveAllChildrenFromContainer(mcjCtnWhole);

                        let objCallbackData = {
                            "Action": "CanvasStopPlaying"
                        }
                        props.CallbackRef(objCallbackData)

                        // fireEvent('PlayEnded');
                    } // end of else  4 if (mintCurrentPlaybackPathIdx < objPlaybackClip.Path.length - 1) 
                } // end of if (objPath4Playback.Points.length == intCount)
            } // end of if (objPath4Playback.Points.length >= 1)

    } // end of DrawPlaybackObjects

    function RedrawPath(PathObject, WrapperContainer)
    {
    	console.log(COMP_NAME + ".RedrawPath: ", PathObject, WrapperContainer);

            let arrPathPoints = PathObject.Points.map(function (Point) {
                
                let objPoint = JSON.parse(JSON.stringify(Point))
                objPoint.X = Point.X * props.InitParam.DevicePixelRatio; 
                objPoint.Y = Point.Y * props.InitParam.DevicePixelRatio;

                return objPoint
            })
            
            // Draw
            // var strCompositeOperation = "source-over";

            var i = 0;
            var intCountPoints = PathObject.Points.length;
            // var strColor = PathObject.Color;
            // var intPenSize = PathObject.PenSize;
            var strColor = PEN_COLOR;
            var intPenSize = PEN_SIZE;

            if (!mblnRedraw1stPieceOfPath)
            {
            	console.log("mblnRedraw1stPieceOfPath: ", mblnRedraw1stPieceOfPath, WrapperContainer.numChildren);
        		WrapperContainer.removeChildAt(WrapperContainer.numChildren - 1);
            }
        	mblnRedraw1stPieceOfPath = false;

            var cjPath = new CreateJSLibs.Instance.Shape();
            WrapperContainer.addChild(cjPath);

            var objControlPoint = {
                "X": 0,
                "Y": 0
            };
            var objNewPoint = {
                "X": 0,
                "Y": 0
            };
            if (intCountPoints >= 3)
            {
                // cjPath.graphics.beginStroke(strColor).setStrokeStyle(intPenSize, "round").moveTo(PathObject.Points[0].X * props.InitParam.DevicePixelRatio, PathObject.Points[0].Y * props.InitParam.DevicePixelRatio);
                cjPath.graphics.beginStroke(strColor).setStrokeStyle(intPenSize, "round").moveTo(arrPathPoints[0].X, arrPathPoints[0].Y);
                for (i = 1; i < intCountPoints - 2; i++)
                {
                    objControlPoint.X = arrPathPoints[i].X;
                    objControlPoint.Y = arrPathPoints[i].Y;
                    objNewPoint.X = (arrPathPoints[i].X + arrPathPoints[i + 1].X) / 2;
                    objNewPoint.Y = (arrPathPoints[i].Y + arrPathPoints[i + 1].Y) / 2;

                    // objControlPoint.X *= props.InitParam.DevicePixelRatio
                    // objControlPoint.Y *= props.InitParam.DevicePixelRatio
                    // objNewPoint.X *= props.InitParam.DevicePixelRatio
                    // objNewPoint.Y *= props.InitParam.DevicePixelRatio

                    cjPath.graphics.quadraticCurveTo(objControlPoint.X, objControlPoint.Y, objNewPoint.X, objNewPoint.Y);
                }
                // cjPath.graphics.quadraticCurveTo(PathObject.Points[i].X * props.InitParam.DevicePixelRatio, PathObject.Points[i].Y * props.InitParam.DevicePixelRatio, PathObject.Points[i + 1].X * props.InitParam.DevicePixelRatio, PathObject.Points[i + 1].Y * props.InitParam.DevicePixelRatio);
                cjPath.graphics.quadraticCurveTo(arrPathPoints[i].X, arrPathPoints[i].Y, arrPathPoints[i + 1].X, arrPathPoints[i + 1].Y);
            }
            else if (intCountPoints === 2)
            {
                // cjPath.graphics.beginStroke(strColor).setStrokeStyle(intPenSize, "round").moveTo(PathObject.Points[0].X * props.InitParam.DevicePixelRatio, PathObject.Points[0].Y * props.InitParam.DevicePixelRatio);
                cjPath.graphics.beginStroke(strColor).setStrokeStyle(intPenSize, "round").moveTo(arrPathPoints[0].X, arrPathPoints[0].Y);
                for (i = 1; i < intCountPoints; i++)
                {
                    // cjPath.graphics.lineTo(PathObject.Points[i].X * props.InitParam.DevicePixelRatio, PathObject.Points[i].Y * props.InitParam.DevicePixelRatio);
                    cjPath.graphics.lineTo(arrPathPoints[i].X, arrPathPoints[i].Y);
                }
                cjPath.graphics.endStroke();
            }
            else if (intCountPoints === 1)
            {
                cjPath.graphics.beginFill(strColor);
                // cjPath.graphics.drawCircle(PathObject.Points[0].X * props.InitParam.DevicePixelRatio, PathObject.Points[0].Y * props.InitParam.DevicePixelRatio, intPenSize / 2);
                cjPath.graphics.drawCircle(arrPathPoints[0].X, arrPathPoints[0].Y, intPenSize / 2);
            }
    } // end of RedrawPath

    function StartPlayback() 
    {
        console.log(COMP_NAME + ".StartPlayback: ")
        if (!mblnInPlayback)
        {
            CreateJSLibs.AddTickRef(COMP_NAME, HandleTick);
            CreateJSLibs.ResumeTick()

            mblnInPlayback = true;            
        }

    } // end of StartPlayback

    function StopPlayback()
    {
        if (mblnInPlayback)
        {
            // CreateJSLibs.Instance.Ticker.paused = true;
            CreateJSLibs.PauseTick()
            CreateJSLibs.RemoveTickRef(COMP_NAME);

            mblnInPlayback = false;            
        }
    }

    function ClearCanvas()
    {
        console.log(COMP_NAME + ".ClearCanvas: ")

        if (mblnInPlayback)
        {
            return;
        }

        marrDrawedPathList = []
        if (mcjCtnWhole !== null)
        {
            mcjCtnWhole.uncache();     // uncache 如果沒有先 Cache, 好像不會有問題
            RemoveAllChildrenFromContainer(mcjCtnWhole);
        }

        mcjCtnWhole.cache(0, 0, mcjCtnWhole.InitWidth, mcjCtnWhole.InitHeight);
        mcjStage.update();

        mintPathCount = 0;
        mbln1stStroke = true
    }

    function GetCanvasImag()
    {
        console.log(COMP_NAME + ".GetCanvasImag: ")

        let strImageBase64String = mobjCanvas.toDataURL("image/png");

        let objCallbackData = {
            "Action": "CanvasImageGotton",
            "ImageBase64": strImageBase64String
        }
        props.CallbackRef(objCallbackData)
    }
    function Initialize()
    {
        console.log(COMP_NAME + ".Initialize: ")

        marrDrawedPathList = []
        mbln1stStroke = true
        RegisterCalledFunctions()

        // StartGame()
    }
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        mobjCanvas = mrefCanvas.current
        console.log("mobjCanvas: ", mobjCanvas)

        // new a stage based on this canvas
        mcjStage = new CreateJSLibs.Instance.Stage(mobjCanvas);

        // InitDrawBG(props.InitParam.CanvasLeftLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasTopLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasWidthLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasHeightLP * props.InitParam.DevicePixelRatio);
        InitDrawBG(props.InitParam.CanvasLeftLP, props.InitParam.CanvasTopLP, props.InitParam.CanvasWidthLP, props.InitParam.CanvasHeightLP);
        
        // begin init drawed objects: physical points
        InitCtnWhole(props.InitParam.CanvasLeftLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasTopLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasWidthLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasHeightLP * props.InitParam.DevicePixelRatio);

        mcjDrawingTemp = new CreateJSLibs.Instance.Shape();
        mcjDrawingTemp.visible = false;

        // enable touch if needed
        var blnSingleTouch = true;
        var blnAllowDefault = false;
        EnableTouchIfNeed(mcjStage, blnSingleTouch, blnAllowDefault);

        // begin init workding (drawing) layer: physical points
        InitWorkingArea(props.InitParam.CanvasLeftLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasTopLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasWidthLP * props.InitParam.DevicePixelRatio, props.InitParam.CanvasHeightLP * props.InitParam.DevicePixelRatio);
        // end of init workding (drawing) layer: physical points

        InitCanvasBounds();
        InitStageBounds();


        if (mcjCtnWhole !== null)
        {
            mcjCtnWhole.uncache();     // uncache 如果沒有先 Cache, 好像不會有問題
            RemoveAllChildrenFromContainer(mcjCtnWhole);
        }

        mcjCtnWhole.cache(0, 0, mcjCtnWhole.InitWidth, mcjCtnWhole.InitHeight);
        mcjStage.update();

    }

    function RemoveAllChildrenFromContainer(SourceContainer)
    {
        var i = 0;
        var intCount = SourceContainer.numChildren;
        var objChild;
        for (i = 0; i < intCount; i++)
        {
            objChild = SourceContainer.getChildAt(i);

            if (typeof(objChild.graphics) !== 'undefined')
            {
                objChild.graphics.clear();
            }
        }
        SourceContainer.removeAllChildren();
    }

    function InitCanvasBounds()
    {
        // mobjCanvas.style.width = WORKING_AREA_W.toString() + "px";
        // mobjCanvas.style.height = WORKING_AREA_H.toString() + "px";
        mobjCanvas.style.width = props.InitParam.CanvasWidthLP.toString() + "px";
        mobjCanvas.style.height = props.InitParam.CanvasHeightLP.toString() + "px";
        mobjCanvas.style.left = WORKING_AREA_LEFT.toString() + "px";
        mobjCanvas.style.top = WORKING_AREA_TOP.toString() + "px";
    } // end of InitCanvasBounds

    function InitStageBounds()
    {
        mcjStage.x = 0;
        mcjStage.y = 0;
        mcjStage.scaleX = 1;
        mcjStage.scaleY = 1;
    } // end of InitStageBounds


    function InitWorkingArea(Left, Top, Width, Height)
    {
        console.log("InitWorkingArea: ", Left, Top, Width, Height);

        // add events
        mcjCtnWhole.hitArea = new CreateJSLibs.Instance.Shape(new CreateJSLibs.Instance.Graphics().f("#000").drawRect(0, 0, Width, Height));
        MakeOnWorkingLayerDrawable();
    } // end of InitWorkingArea

    function MakeOnWorkingLayerDrawable()
    {
        if (!mcjCtnWhole.hasEventListener("mousedown"))
        {
            mcjCtnWhole.addEventListener('mousedown', function (e) {
                MouseDownHandler(EventModeEnum.Mouse, e);
            }, false);
            mcjStage.addEventListener('stagemousemove', function (e) 
            {
                MouseMoveHandler(EventModeEnum.Mouse, e);
            });
            mcjStage.addEventListener('stagemouseup', function (e) 
            {
                MouseUpHandler(EventModeEnum.Mouse, e);
            });
            mcjStage.addEventListener('mouseleave', function (e) 
            {
                MouseUpHandler(EventModeEnum.Mouse, e);
            });
        }

        // Chrome Book 需要用 Touch Event       Tim22.11.02
        mobjCanvas.addEventListener('touchstart', function (e) {
            e.preventDefault()
            MouseDownHandler(EventModeEnum.Touch, e)
        }, false)

        mobjCanvas.addEventListener('touchmove', function (e) {
            e.preventDefault()
            MouseMoveHandler(EventModeEnum.Touch, e)
        }, false)

        mobjCanvas.addEventListener('touchend', function (e) {
            e.preventDefault()
            MouseUpHandler(EventModeEnum.Touch, e)
        }, false)
    }   

    function IsInCtnWorking(PosX, PosY)
    {
        if (
            ((PosX >= 0) && (PosX <= props.InitParam.CanvasWidthLP * props.InitParam.DevicePixelRatio)) &&
            ((PosY >= 0) && (PosY <= props.InitParam.CanvasHeightLP * props.InitParam.DevicePixelRatio)) 
            )
        {
            return true;

        }
        else
        {
            return false;
        }
    }

    function PointNeed2Remove (NewPointX, NewPointY, NewTime) 
    {
        // console.log("PointNeed2Remove: ", NewPointX, NewPointY, NewTime);
        // body...

        var intCountPoints = mobjCurrentPath.Points.length;


        if (intCountPoints <= 3)    // 先讓3個Point進入Line Path
        {
            return false;
        }
        else
        {
            var blnNeed2Remove = false;
            var intMinDistance = 3;     // 跟上一個點的距離差3px
            var intMinTime = 200;       // 跟上一個點的時間差100ms
            // 兩個條件 "AND" 的話，才成立

            var fltLastPointX = mobjCurrentPath.Points[intCountPoints - 1].X;
            var fltLastPointY = mobjCurrentPath.Points[intCountPoints - 1].Y;
            var intLastPointT = mobjCurrentPath.Points[intCountPoints - 1].T;


            var intDeltaX = NewPointX - fltLastPointX;
            var intDeltaY = NewPointY - fltLastPointY;

            if (
                ((NewTime - intLastPointT) < intMinTime) && 
                (((intDeltaX * intDeltaX) + (intDeltaY * intDeltaY)) < (intMinDistance * intMinDistance))
                )
            {
                blnNeed2Remove = true;
            }

            if (blnNeed2Remove)
            {
                console.log("blnNeed2Remove: ", blnNeed2Remove);
            }
            return blnNeed2Remove;
        }
    }

    function MouseUpHandler (EventMode, e)
    {
        // console.log("MouseUpHandler", mblnBeginDrawing);

        e.preventDefault();
        e.stopPropagation();

        if (!mblnBeginDrawing || mblnInPlayback)
        {
            return;
        }

        // var i;
        var intCount = 0;
        // var objPointX, objPointY;
        // var objPointPrevX, objPointPreY;
        // var intPenSize = PEN_SIZE * props.InitParam.DevicePixelRatio; // * mfltScaledRatio;
        var intPenSize = PEN_SIZE; // * mfltScaledRatio;

        if ((typeof(mobjCurrentPath) !== 'undefined') && 
            (mobjCurrentPath !== null) &&
            (typeof(mobjCurrentPath.Points) !== 'undefined') && 
            (mobjCurrentPath.Points !== null) && 
            (mobjCurrentPath.Points.length > 0)
            )
        {
            //新增EndTime
            mobjCurrentPath.ET = new Date().getTime();  // EndTime
            
            var cjMove = new CreateJSLibs.Instance.Shape();
            mcjCtnWhole.addChild(cjMove);

            intCount = mobjCurrentPath.Points.length;
            if (intCount > 2)
            {
                // // For the last 2 points
                // tmp_ctx.quadraticCurveTo(
                //     ppts[i].x,
                //     ppts[i].y,
                //     ppts[i + 1].x,
                //     ppts[i + 1].y
                // );
                // tmp_ctx.stroke();

                var intLastIdx = mobjCurrentPath.Points.length - 1;
                var objOldPoint = {
                    "X": Math.round((mobjCurrentPath.Points[intLastIdx - 2].X + mobjCurrentPath.Points[intLastIdx - 1].X) / 2),
                    "Y": Math.round((mobjCurrentPath.Points[intLastIdx - 2].Y + mobjCurrentPath.Points[intLastIdx - 1].Y) / 2)
                };
                var objControlPoint = {
                    "X": mobjCurrentPath.Points[intLastIdx - 1].X,
                    "Y": mobjCurrentPath.Points[intLastIdx - 1].Y
                };
                var objNewPoint = {
                    "X": mobjCurrentPath.Points[intLastIdx].X,
                    "Y": mobjCurrentPath.Points[intLastIdx].Y
                };

                console.log(objOldPoint, objControlPoint, objNewPoint);

                objOldPoint.X *= props.InitParam.DevicePixelRatio;
                objOldPoint.Y *= props.InitParam.DevicePixelRatio;
                objControlPoint.X *= props.InitParam.DevicePixelRatio;
                objControlPoint.Y *= props.InitParam.DevicePixelRatio;
                objNewPoint.X *= props.InitParam.DevicePixelRatio;
                objNewPoint.Y *= props.InitParam.DevicePixelRatio;

                cjMove.graphics.beginStroke(PEN_COLOR).setStrokeStyle(intPenSize, "round");
                cjMove.graphics.moveTo(objOldPoint.X, objOldPoint.Y);
                cjMove.graphics.quadraticCurveTo(objControlPoint.X, objControlPoint.Y, objNewPoint.X, objNewPoint.Y).endStroke();

                mcjDrawingTemp.graphics.beginStroke(PEN_COLOR).setStrokeStyle(intPenSize, "round");
                mcjDrawingTemp.graphics.moveTo(objOldPoint.X, objOldPoint.Y);
                mcjDrawingTemp.graphics.quadraticCurveTo(objControlPoint.X, objControlPoint.Y, objNewPoint.X, objNewPoint.Y).endStroke();
            }
            else if (intCount === 2)
            {
                cjMove.graphics.beginStroke(PEN_COLOR).setStrokeStyle(intPenSize, "round");
                cjMove.graphics.moveTo(mobjCurrentPath.Points[0].X * props.InitParam.DevicePixelRatio, mobjCurrentPath.Points[0].Y * props.InitParam.DevicePixelRatio);        
                cjMove.graphics.lineTo(mobjCurrentPath.Points[intCount - 1].X * props.InitParam.DevicePixelRatio, mobjCurrentPath.Points[intCount - 1].Y * props.InitParam.DevicePixelRatio).endStroke();

                mcjDrawingTemp.graphics.beginStroke(PEN_COLOR).setStrokeStyle(intPenSize, "round");
                mcjDrawingTemp.graphics.moveTo(mobjCurrentPath.Points[0].X * props.InitParam.DevicePixelRatio, mobjCurrentPath.Points[0].Y * props.InitParam.DevicePixelRatio);        
                mcjDrawingTemp.graphics.lineTo(mobjCurrentPath.Points[intCount - 1].X * props.InitParam.DevicePixelRatio, mobjCurrentPath.Points[intCount - 1].Y * props.InitParam.DevicePixelRatio).endStroke();
            }
            else if (intCount === 1)
            {
                cjMove.graphics.beginFill(PEN_COLOR);
                cjMove.graphics.drawCircle(mobjCurrentPath.Points[0].X * props.InitParam.DevicePixelRatio, mobjCurrentPath.Points[0].Y * props.InitParam.DevicePixelRatio, intPenSize / 2);

                mcjDrawingTemp.graphics.beginFill(PEN_COLOR);
                mcjDrawingTemp.graphics.drawCircle(mobjCurrentPath.Points[0].X * props.InitParam.DevicePixelRatio, mobjCurrentPath.Points[0].Y * props.InitParam.DevicePixelRatio, intPenSize / 2);
            }

            var strCompositeOperation = "source-over";
            mcjCtnWhole.updateCache(strCompositeOperation);
            
            cjMove.graphics.clear();
            mcjCtnWhole.removeChild(cjMove);

            mcjStage.update();

            // clone the drawing temp object to be a path layer which need to be added into Whole container
            var cjFullPath = mcjDrawingTemp.clone(true);
            cjFullPath.compositeOperation = "source-over";
            mcjCtnWhole.addChild(cjFullPath);
            mcjDrawingTemp.graphics.clear();

            marrDrawedPathList.push(mobjCurrentPath)
            // fireEvent('PathUpdated', mobjCurrentPath);
            mobjCurrentPath = {};
            mintPathCount++;
        }

        mblnBeginDrawing = false;

        if (mbln1stStroke)
        {
            let objCallbackData = {
                "Action": "1stStroke"
            }
            props.CallbackRef(objCallbackData)
                
            mbln1stStroke = false
        }

        // fireEvent('EndDrawing');


    } // end of MouseUpHandler


    function MouseMoveHandler (EventMode, e)
    {
    	// console.log(COMP_NAME + ".MouseMoveHandler: ", e);

        e.preventDefault();
        e.stopPropagation();

        if (!mblnBeginDrawing || mblnInPlayback)
        {
            return;
        }

        let intOffsetX = 0
        let intOffsetY = 0

        if (EventMode === EventModeEnum.Touch)
        {
            // Chrome Book 需要用 Touch Event       Tim22.11.02
            console.log("MouseMoveHandler Touch")
            let objCanvasBoudingRect = mobjCanvas.getBoundingClientRect()
            intOffsetX = e.targetTouches[0].clientX - objCanvasBoudingRect.left
            intOffsetY = e.targetTouches[0].clientY - objCanvasBoudingRect.top

            console.log("MouseMoveHandler objCanvasBoudingRect: ", objCanvasBoudingRect)
            console.log("MouseMoveHandler targetTouches: ", e.targetTouches[0])
        }
        else
        {
            // mouse
            console.log("MouseMoveHandler Mouse")
            console.log("MouseMoveHandler stageX: ", e.stageX)
            console.log("MouseMoveHandler stageY: ", e.stageY)
            intOffsetX = e.stageX
            intOffsetY = e.stageY
        }

        console.log("MouseMoveHandler intOffsetX: ", intOffsetX)
        console.log("MouseMoveHandler intOffsetY: ", intOffsetY)

        // var intPenSize = PEN_SIZE * props.InitParam.DevicePixelRatio;
        var intPenSize = PEN_SIZE;
        var cjLocalPoint = mcjCtnWhole.globalToLocal(intOffsetX, intOffsetY);
        if (!IsInCtnWorking(cjLocalPoint.x, cjLocalPoint.y))
        {
            // fire mouse up
            MouseUpHandler(e);
            return;
        }

        var fltPosX = cjLocalPoint.x;
        var fltPosY = cjLocalPoint.y;
        var intPosT = new Date().getTime() - mintPathBeginTime;

        if (PointNeed2Remove((fltPosX / props.InitParam.DevicePixelRatio), (fltPosY / props.InitParam.DevicePixelRatio), intPosT))
        {
            return;
        }

        mobjLastPoint.X = fltPosX;
        mobjLastPoint.Y = fltPosY;

        mobjCurrentPath.Points.push({
            "X": mobjLastPoint.X / props.InitParam.DevicePixelRatio,
            "Y": mobjLastPoint.Y / props.InitParam.DevicePixelRatio,
            "T": intPosT
        });

        if (mobjCurrentPath.Points.length >= 3)
        {
            var intLastIdx = mobjCurrentPath.Points.length - 1;

            let objOldPoint = {}

            if (mobjCurrentPath.Points.length === 3)
            {
                objOldPoint = {
                    "X": mobjCurrentPath.Points[0].X,
                    "Y": mobjCurrentPath.Points[0].Y
                };
            }
            else
            {
                objOldPoint = {
                    "X": Math.round((mobjCurrentPath.Points[intLastIdx - 2].X + mobjCurrentPath.Points[intLastIdx - 1].X) / 2),
                    "Y": Math.round((mobjCurrentPath.Points[intLastIdx - 2].Y + mobjCurrentPath.Points[intLastIdx - 1].Y) / 2)
                };
            }
            var objControlPoint = {
                "X": mobjCurrentPath.Points[intLastIdx - 1].X,
                "Y": mobjCurrentPath.Points[intLastIdx - 1].Y
            };
            var objNewPoint = {
                "X": Math.round((mobjCurrentPath.Points[intLastIdx - 1].X + mobjCurrentPath.Points[intLastIdx].X) / 2),
                "Y": Math.round((mobjCurrentPath.Points[intLastIdx - 1].Y + mobjCurrentPath.Points[intLastIdx].Y) / 2)
            };

            var cjMove = new CreateJSLibs.Instance.Shape();
            mcjCtnWhole.addChild(cjMove);

            objOldPoint.X *= props.InitParam.DevicePixelRatio;
            objOldPoint.Y *= props.InitParam.DevicePixelRatio;
            objControlPoint.X *= props.InitParam.DevicePixelRatio;
            objControlPoint.Y *= props.InitParam.DevicePixelRatio;
            objNewPoint.X *= props.InitParam.DevicePixelRatio;
            objNewPoint.Y *= props.InitParam.DevicePixelRatio;

            cjMove.graphics.beginStroke(PEN_COLOR).setStrokeStyle(intPenSize, "round");
            cjMove.graphics.moveTo(objOldPoint.X, objOldPoint.Y);
            cjMove.graphics.quadraticCurveTo(objControlPoint.X, objControlPoint.Y, objNewPoint.X, objNewPoint.Y).endStroke();

            mcjDrawingTemp.graphics.beginStroke(PEN_COLOR).setStrokeStyle(intPenSize, "round");
            mcjDrawingTemp.graphics.moveTo(objOldPoint.X, objOldPoint.Y);
            mcjDrawingTemp.graphics.quadraticCurveTo(objControlPoint.X, objControlPoint.Y, objNewPoint.X, objNewPoint.Y).endStroke();


            var strCompositeOperation = "source-over";
            mcjCtnWhole.updateCache(strCompositeOperation);

            cjMove.graphics.clear();
            mcjCtnWhole.removeChild(cjMove);

            mcjStage.update();
        }
    } // end of MouseMoveHandler    

    function MouseDownHandler (EventMode, e)
    {
        console.log(COMP_NAME + ".MouseDownHandler: ", e)
        // console.log("MouseDownHandler: x", e.stageX);
        // console.log("MouseDownHandler: Y", e.stageY);

        e.preventDefault();
        e.stopPropagation();

        // createjs事件 要用 e.nativeEvent.button 判斷 滑鼠按鍵
        if (
            (EventMode === EventModeEnum.Mouse) &&
            (!window.gSession.App.InApp) &&
            (e.nativeEvent.button !== 0)
            )
        {
            // 0: 左鍵，1: 滾輪，2: 右鍵
            return 
        }
        else if (mblnBeginDrawing || mblnInPlayback || (mintPathCount >= PATH_MAX_NUM))
        {
        	return;
        }

        mblnBeginDrawing = true;
        // fireEvent('BeginDrawing');

        let intOffsetX = 0
        let intOffsetY = 0

        if (EventMode === EventModeEnum.Touch)
        {
            // Chrome Book 需要用 Touch Event       Tim22.11.02
            console.log("MouseDownHandler Touch")
            let objCanvasBoudingRect = mobjCanvas.getBoundingClientRect()
            intOffsetX = e.targetTouches[0].clientX - objCanvasBoudingRect.left
            intOffsetY = e.targetTouches[0].clientY - objCanvasBoudingRect.top

            console.log("MouseDownHandler objCanvasBoudingRect: ", objCanvasBoudingRect)
            console.log("MouseDownHandler targetTouches: ", e.targetTouches[0])
        }
        else
        {
            // mouse
            console.log("MouseDownHandler Mouse")
            console.log("MouseDownHandler stageX: ", e.stageX)
            console.log("MouseDownHandler stageY: ", e.stageY)
            intOffsetX = e.stageX
            intOffsetY = e.stageY
        }

        console.log("MouseDownHandler intOffsetX: ", intOffsetX)
        console.log("MouseDownHandler intOffsetY: ", intOffsetY)


        mintPathBeginTime = new Date().getTime();
        mobjCurrentPath = {};
        var cjLocalPoint = mcjCtnWhole.globalToLocal(intOffsetX, intOffsetY);
        var fltPosX = cjLocalPoint.x;
        var fltPosY = cjLocalPoint.y;

        mobjLastPoint.X = fltPosX;
        mobjLastPoint.Y = fltPosY;

        mobjCurrentPath.BT = mintPathBeginTime;
        mobjCurrentPath.Points = [];
        mobjCurrentPath.Points.push({
            "X": fltPosX / props.InitParam.DevicePixelRatio,
            "Y": fltPosY / props.InitParam.DevicePixelRatio,
            "T": 0
        });

        console.log("mobjCurrentPath: ", mobjCurrentPath);

    }
    function EnableTouchIfNeed (StageObject, IsSingleTouch, AllowDefault)
    {
        // console.log("utilWBGlobals.EnableTouchIfNeed: ", StageObject, IsSingleTouch, AllowDefault);
        console.log("utilWBGlobals.EnableTouchIfNeed: ", IsSingleTouch, AllowDefault);

        // // Windows 的 IE, Edge 不開放 touch, 但 Touch Screen 其實可以運作
        // if ((Ext.os.name !== "Windows") || (DCP.app.gSession.App.BrowserType4LogTrace == DCP.app.gBrowserTypeEnum.Chrome))
        // {
            CreateJSLibs.Instance.Touch.enable(StageObject, IsSingleTouch, AllowDefault);
        // }
    }

    function InitCtnWhole(Left, Top, Width, Height)
    {
        mcjCtnWhole = new CreateJSLibs.Instance.Container();
        mcjCtnWhole.x = Left;
        mcjCtnWhole.y = Top;
        mcjCtnWhole.InitWidth = Width;
        mcjCtnWhole.InitHeight = Height;
        // mcjCtnWhole.visible = true;

        mcjStage.addChild(mcjCtnWhole);

    } // end of InitCtnWhole

    function InitDrawBG(Left, Top, Width, Height)
    {
        console.log(COMP_NAME + ".InitDrawBG: ", Left, Top, Width, Height);

        var cjLine = new CreateJSLibs.Instance.Shape();

        console.log("xxx: ", cjLine.scale)
        cjLine.graphics.beginStroke(DRAW_BG_LINE_COLOR).setStrokeStyle(3);
        
        // cjLine.graphics.moveTo(Left, Top).lineTo(Width, Top).lineTo(320, 320)// .lineTo(Left, Height).lineTo(Left, Top);
        // cjLine.graphics.moveTo(Left, Top).lineTo(Width, Top)
        // cjLine.graphics.moveTo(10, Top).lineTo(280, 120)// .lineTo(Left, Height).lineTo(Left, Top);
        cjLine.graphics.moveTo(Left, Top).lineTo(Width, Top).lineTo(Width, Height).lineTo(Left, Height).lineTo(Left, Top);
        // cjLine.graphics.moveTo(Width,0).lineTo(0, Height);
        // cjLine.graphics.moveTo(Width / 2, 0).lineTo(Width / 2, Height);
        // cjLine.graphics.moveTo(0, Height / 2).lineTo(Width, Height / 2);

        cjLine.graphics.endStroke();


        cjLine.graphics.beginStroke(DRAW_BG_LINE_COLOR).setStrokeStyle(1).setStrokeDash([2, 2]);
        
        cjLine.graphics.moveTo(Left, Top).lineTo(Width, Height);
        cjLine.graphics.moveTo(Width,0).lineTo(0, Height);
        cjLine.graphics.moveTo(Width / 2, 0).lineTo(Width / 2, Height);
        cjLine.graphics.moveTo(0, Height / 2).lineTo(Width, Height / 2);

        cjLine.graphics.endStroke();

        mcjStage.addChild(cjLine);
        mcjStage.update();        
    }
    
    function ReanderMain(InitParam) {
        console.log(COMP_NAME + ".ReanderMain: ", InitParam)
        // "CanvasWidthLP": WORKING_AREA_W,      // LP: Logic Point
        // "CanvasHeightLP": WORKING_AREA_H,      // LP: Logic Point
        // "CanvasLeftLP": 0,
        // "CanvasTopLP": 0,
        // "DevicePixelRatio": window.devicePixelRatio     // iPad Retina: 2    

        let objStyle = {
            // width: InitParam.CanvasWidthLP * InitParam.DevicePixelRatio,
            // height: InitParam.CanvasHeightLP * InitParam.DevicePixelRatio,
            left: InitParam.CanvasLeftLP,
            top: InitParam.CanvasTopLP,
            // position: "absolute",
            // border: "solid 1px green",
            background: "white"
        }
        return (
            <>
                <canvas width={InitParam.CanvasWidthLP.toString() + "px"} height={InitParam.CanvasWidthLP.toString() + "px"} ref={mrefCanvas} style={objStyle}></canvas>
            </>
        )
    }
    return (
        <div>
            {ReanderMain(props.InitParam)}
        </div>
    )
}

export default CharacterDrawerCanvas
